import createModule from "../createModule"
import { getEmailSent, getErrorMessage, getEmail } from "./selectors/index"
import { Creators } from "./model"
import view from "./view"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    emailSent: getEmailSent(state, props),
    errorMessage: getErrorMessage(state, props),
    email: getEmail(state, props),
  }),
  actions: {
    ...Creators,
  },
})
